import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Box,
    TextField,
    DialogTitle,
    DialogActions,
    FormControl,
    FormHelperText,
    OutlinedInput,
    InputLabel,
    Select,
    Button,
    DialogContent,
    Dialog,
} from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

import MenuItem from "@mui/material/MenuItem";

import { DataTypes } from "../../../../constants";
import rmsActions from "../../../../actions/rmsActions";
import { getAppraisers, isFetching } from "../../../../reducers";

function AppraisalFormDialog(props) {
    const dispatch = useDispatch();

    const fetching = useSelector((state) =>
        isFetching(state, DataTypes.RMS_APPRAISERS)
    );
    let appraisers = useSelector((state) => getAppraisers(state));

    if (!fetching && appraisers === null && !!props.appCode) {
        dispatch(rmsActions.getAppraisers(props.appCode));
        appraisers = [];
    }

    return (
        <Dialog
            open={!!props.open}
            onClose={props.onClose}
            fullWidth={true}
            maxWidth="md"
        >
            <DialogTitle>{props.formTitle || "Appraisal"}</DialogTitle>
            <DialogContent dividers={false}>
                <Box
                    component="form"
                    autoComplete="off"
                    noValidate
                    className="dialog-content"
                    onSubmit={(e) => e.preventDefault()}
                >
                    <FormControl
                        component="div"
                        margin={"normal"}
                        fullWidth={true}
                        required={true}
                        error={!props.title}
                    >
                        <InputLabel
                            id="label-title"
                            sx={{ backgroundColor: "#FFF", padding: "0 4px" }}
                        >
                            Title
                        </InputLabel>
                        <OutlinedInput
                            id="text-title"
                            value={props.title}
                            onChange={({ target }) =>
                                props.setTitle(target.value)
                            }
                            inputProps={{ maxLength: 80 }}
                            multiline={false}
                            autoFocus={true}
                        />
                        <FormHelperText>
                            Give this appraisal a title (up to 80 characters)
                        </FormHelperText>
                    </FormControl>

                    {appraisers?.length > 0 && (
                        <FormControl
                            component="div"
                            margin="normal"
                            fullWidth={true}
                            required={true}
                            error={!props.appraiser.uuid}
                        >
                            <InputLabel
                                id="label-type"
                                sx={{
                                    backgroundColor: "#FFF",
                                    padding: "0 4px",
                                }}
                            >
                                Appraiser
                            </InputLabel>

                            <Select
                                id="select-appraiser"
                                value={props.appraiser?.uuid}
                                onChange={({ target }) =>
                                    props.setAppraiser(
                                        appraisers.find(
                                            ({ uuid }) => uuid === target.value
                                        )
                                    )
                                }
                            >
                                {appraisers?.length > 0 &&
                                    appraisers.map((item) => (
                                        <MenuItem
                                            key={item.uuid}
                                            value={item.uuid}
                                        >
                                            {item?.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                            <FormHelperText>Select appraiser</FormHelperText>
                        </FormControl>
                    )}

                    <FormControl
                        component="div"
                        margin={"normal"}
                        error={!props.meetingDate}
                    >
                        <DatePicker
                            id="date-meeting"
                            label="Meeting"
                            format="DD/MM/YYYY"
                            minDate={dayjs(props.minDate)}
                            value={dayjs(props.meetingDate)}
                            onChange={props.setMeetingDate}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </FormControl>

                    <FormControl
                        component="div"
                        margin={"normal"}
                        fullWidth={true}
                        required={false}
                    >
                        <InputLabel
                            id="label-notes"
                            sx={{ backgroundColor: "#FFF", padding: "0 4px" }}
                        >
                            Notes
                        </InputLabel>
                        <OutlinedInput
                            id="text-notes"
                            value={props.meetingNotes}
                            onChange={({ target }) =>
                                props.setMeetingNotes(target.value)
                            }
                            inputProps={{ maxLength: 250 }}
                            multiline={true}
                            rows={2}
                        />
                        <FormHelperText>
                            Add any notes you feel may be useful (up to 250
                            characters)
                        </FormHelperText>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={props.onClose}>
                    Cancel
                </Button>
                <Button
                    key="save"
                    variant="contained"
                    color="primary"
                    onClick={props.onSubmit}
                    disabled={!props.title}
                    disableElevation={true}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AppraisalFormDialog;
